"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _web3CoreRequestmanager = require("web3-core-requestmanager");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class HttpRequestManager {
  constructor(host, options) {
    options = options || {};
    this.host = host;
    const config = {
      timeout: options.timeout || 15000,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    if (options.headers) {
      options.headers.forEach(header => {
        config.headers[header.name] = header.value;
      });
    }

    this.request = _axios.default.create(config);
    return new _web3CoreRequestmanager.Manager(this);
  }

  send(payload, callback) {
    this.request.post(this.host, payload).then(result => {
      callback(null, result.data);
    }).catch(err => {
      callback(err);
    });
  }

  disconnect() {}

}

var _default = HttpRequestManager;
exports.default = _default;